/* Default indicators will have a non-zero master ID. These should only show a limited subset of
   possible target populations. Since custom indicators could be anything, let the user choose from
   any target population for those. */
import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import {
    getDefIndAgeLowerBoundEnd,
    getDefIndAgeLowerBoundStart,
    getDefIndAgeUpperBoundEnd,
    getDefIndAgeUpperBoundStart,
    getDefIndGender,
    getDefIndPossibleTargPop1DIntArray,
    getDefIndRefPeriod,
    getDefIndCurrIDFromTargPopCurrID,
    createIndObj,
} from "./RCUtil";
import * as rcc from "./RCConst";
import {
    getGenderPlural
} from "../../GB/GBUtil";
import * as rcu from "./RCUtil";

export function getDrawerID_AS(appState) {

    return appState[rcc.drawerID_AS_C];

}

export function setDrawerID_AS(appState, value) {

    appState[rcc.drawerID_AS_C] = value;

}

export function getDrawerOpen_AS(appState) {

    return appState[rcc.drawerOpen_AS_C];

}

export function setDrawerOpen_AS(appState, value) {

    appState[rcc.drawerOpen_AS_C] = value;

}

export function getFailedToLoad_AS(appState) {

    return appState[rcc.failedToLoad_AS_C];

}

export function setFailedToLoad_AS(appState, value) {

    appState[rcc.failedToLoad_AS_C] = value;

}

export function getLanguage_AS(appState) {

    return appState[rcc.language_AS_C];

}

export function setLanguage_AS(appState, value) {

    appState[rcc.language_AS_C] = value;

}

export function getSideBarOpen_AS(appState) {

    return appState[rcc.sideBarOpen_AS_C];

}

export function setSideBarOpen_AS(appState, value) {

    appState[rcc.sideBarOpen_AS_C] = value;

}

export function getAnswer1Byte_AS(appState) {

    return appState[rcc.answer1Byte_AS_C];

}

export function setAnswer1Byte_AS(appState, value) {

    appState[rcc.answer1Byte_AS_C] = value;

}

export function getAnswer2Byte_AS(appState) {

    return appState[rcc.answer2Byte_AS_C];

}

export function setAnswer2Byte_AS(appState, value) {

    appState[rcc.answer2Byte_AS_C] = value;

}

export function getGroupObjList_AS(appState) {

    return appState[rcc.groupObjList_AS_C];

}

export function setGroupObjList_AS(appState, value) {

    appState[rcc.groupObjList_AS_C] = value;

}

export function getIndicatorObjList_AS(appState) {

    return appState[rcc.indicatorObjList_AS_C];

}

export function setIndicatorObjList_AS(appState, value) {

    appState[rcc.indicatorObjList_AS_C] = value;

}

export function getSelectedIndCurrID_AS(appState) {

    return appState[rcc.selectedIndCurrID_AS_C];

}

export function setSelectedIndCurrID_AS(appState, value) {

    appState[rcc.selectedIndCurrID_AS_C] = value;

}

export function getTargPopObjList_AS(appState) {

    return appState[rcc.targPopObjList_AS_C];

}

export function setTargPopObjList_AS(appState, value) {

    appState[rcc.targPopObjList_AS_C] = value;

}

/* Default indicators will have a non-zero master ID. These should only show a limited subset of
   possible target populations. Since custom indicators could be anything, let the user choose from
   any target population for those. */
export function getIndPossibleTargPop1DIntArray(indCurrID, indicatorObjList) {

    let indPossibleTargPop1DIntArray = [];

    const customIndBool = getIndCustomBool(indCurrID, indicatorObjList);

    if (!customIndBool) {

        indPossibleTargPop1DIntArray = getDefIndPossibleTargPop1DIntArray(indCurrID);

    }
    else {

        for (let i = 1; i <= rcc.numDefTargPops; i++) {

            indPossibleTargPop1DIntArray.push(i);

        }

    }

    return indPossibleTargPop1DIntArray;

}

/* Determines if the user selected any indicators to include in the analysis. */
export function getAnyIndicatorSelected(indicatorObjList) {

    let indSelectedBool = false;

    let i = 1;

    while ((i <= indicatorObjList.length) && (!indSelectedBool)) {

        indSelectedBool = indicatorObjList[i - 1][rcc.analyzeBool_I_C];

        i++;

    }

    return indSelectedBool;

}

/* Returns the current ID of the first indicator in the indicator object list amongst the indicators
   selected for analysis. */
export function getFirstIndSelectedForAnalysis(indicatorObjList) {

    let indCurrID = 0;

    let i = 1;

    while ((i <= indicatorObjList.length) && (indCurrID === 0)) {

        if (indicatorObjList[i - 1][rcc.analyzeBool_I_C]) {

            indCurrID = i;

        }

        i++;

    }

    return indCurrID;

}

/******************************   Indicators  ***************************************/

export function getIndObj(indCurrID, indicatorObjList) {

    return indicatorObjList[indCurrID - 1];

}

export function getIndName(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.name_I_C];

}

export function setIndName(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.name_I_C] = value;

}

export function getIndMstID(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.mstID_I_C];

}

export function setIndMstID(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.mstID_I_C] = value;

}

export function getIndAnalyzeBool(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.analyzeBool_I_C];

}

export function setIndAnalyzeBool(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.analyzeBool_I_C] = value;

}

export function getIndCustomBool(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.custom_I_C];

}

export function setIndCustomBool(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.custom_I_C] = value;

}

export function getIndGroupCurrID(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.groupCurrID_I_C];

}

export function setIndGroupCurrID(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.groupCurrID_I_C] = value;

}

export function getIndNumIntervHHs(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.numIntervHHs_I_C];

}

export function setIndNumIntervHHs(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.numIntervHHs_I_C] = value;

}

export function getIndPropHHResponseRate(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.propHHResponseRate_I_C];

}

export function setIndPropHHResponseRate(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.propHHResponseRate_I_C] = value;

}

/**********************   Indicator --> Target populations  *************************/

export function getIndTargPopCurrID(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.targPop_I_TP_C][rcc.currID_I_TP_C];

}

export function setIndTargPopCurrID(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.targPop_I_TP_C][rcc.currID_I_TP_C] = value;

}

export function getIndTargPopType(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.targPop_I_TP_C][rcc.type_I_TP_C];

}

export function setIndTargPopType(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.targPop_I_TP_C][rcc.type_I_TP_C] = value;

}

export function getIndTargPopValue(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.targPop_I_TP_C][rcc.value_I_TP_C];

}

export function setIndTargPopValue(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.targPop_I_TP_C][rcc.value_I_TP_C] = value;

}

export function getIndTargPopLabStartAge(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.targPop_I_TP_C][rcc.labParams_I_TP_LP_C][rcc.startAge_I_TP_LP_C];

}

export function setIndTargPopLabStartAge(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.targPop_I_TP_C][rcc.labParams_I_TP_LP_C][rcc.startAge_I_TP_LP_C] = value;

}

export function getIndTargPopLabEndAge(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.targPop_I_TP_C][rcc.labParams_I_TP_LP_C][rcc.endAge_I_TP_LP_C];

}

export function setIndTargPopLabEndAge(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.targPop_I_TP_C][rcc.labParams_I_TP_LP_C][rcc.endAge_I_TP_LP_C] = value;

}

export function getIndTargPopLabRefPeriod(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.targPop_I_TP_C][rcc.labParams_I_TP_LP_C][rcc.refPeriod_I_TP_LP_C];

}

export function setIndTargPopLabRefPeriod(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.targPop_I_TP_C][rcc.labParams_I_TP_LP_C][rcc.refPeriod_I_TP_LP_C] = value;

}

export function getIndTargPopLabGender(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.targPop_I_TP_C][rcc.labParams_I_TP_LP_C][rcc.gender_I_TP_LP_C];

}

export function setIndTargPopLabGender(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.targPop_I_TP_C][rcc.labParams_I_TP_LP_C][rcc.gender_I_TP_LP_C] = value;

}

export function getIndTargPopCustomStr(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    return indObj[rcc.targPop_I_TP_C][rcc.customStr_I_TP_C];

}

export function setIndTargPopCustomStr(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.targPop_I_TP_C][rcc.customStr_I_TP_C] = value;

}

/************************   Indicator --> Precision inputs   *************************/

export function getIndDesiredNumHHsPr(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    const value = indObj[rcc.precInputs_I_PI_C][rcc.desNumHHsNum_I_PI_C];
    //console.log("Get desired number of households: " + value);
    return value;

}

export function setIndDesiredNumHHsPr(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.precInputs_I_PI_C][rcc.desNumHHsNum_I_PI_C] = value;

    //console.log("Set desired number of households: " + value);
}

export function getIndEstFreqPr(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    const value = indObj[rcc.precInputs_I_PI_C][rcc.estFreqPerc_I_PI_C];
    //console.log("Get estimated frequency: " + value);
    return value;

}

export function setIndEstFreqPr(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.precInputs_I_PI_C][rcc.estFreqPerc_I_PI_C] = value;

    //console.log("Set estimated frequency: " + value);

}

export function getIndDesiredPrecPr(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    const value = indObj[rcc.precInputs_I_PI_C][rcc.desiredPrecNum_I_PI_C];
    //console.log("Get desired precision: " + value);
    return value;

}

export function setIndDesiredPrecPr(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.precInputs_I_PI_C][rcc.desiredPrecNum_I_PI_C] = value;

    //console.log("Set desired precision: " + value);

}

export function getIndDesignEffectPr(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    const value = indObj[rcc.precInputs_I_PI_C][rcc.designEffectNum_I_PI_C];
    //console.log("Get design effect: " + value);
    return value;

}

export function setIndDesignEffectPr(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.precInputs_I_PI_C][rcc.designEffectNum_I_PI_C] = value;

    //console.log("Set design effect: " + value);

}

/**********************   Indicator --> Power-change inputs   *************************/

export function getDesNumHHsPerSurveyPC(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    const value = indObj[rcc.powerChangeInputs_I_PC_C][rcc.desNumHHsPerSurveyNum_I_PC_C];
    //console.log("Get desired number of households per survey: " + value);
    return value;

}

export function setDesNumHHsPerSurveyPC(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.powerChangeInputs_I_PC_C][rcc.desNumHHsPerSurveyNum_I_PC_C] = value;

    //console.log("Set desired number of households per survey: " + value);
}

export function getEstFreqBaselinePC(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    const value = indObj[rcc.powerChangeInputs_I_PC_C][rcc.estFreqBaselinePerc_I_PC_C];
    //console.log("Get frequency baseline: " + value);
    return value;

}

export function setEstFreqBaselinePC(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.powerChangeInputs_I_PC_C][rcc.estFreqBaselinePerc_I_PC_C] = value;

    //console.log("Set frequency baseline: " + value);
}

export function getEstFreqEndlinePC(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    const value = indObj[rcc.powerChangeInputs_I_PC_C][rcc.estFreqEndlinePerc_I_PC_C];
    //console.log("Get frequency endline: " + value);
    return value;

}

export function setEstFreqEndlinePC(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.powerChangeInputs_I_PC_C][rcc.estFreqEndlinePerc_I_PC_C] = value;

    //console.log("Set frequency endline: " + value);

}

export function getIndDesignEffectPC(indCurrID, indicatorObjList) {

    const indObj = getIndObj(indCurrID, indicatorObjList);
    const value = indObj[rcc.powerChangeInputs_I_PC_C][rcc.designEffectNum_I_PC_C];
    //console.log("Get design effect: " + value);
    return value;

}

export function setIndDesignEffectPC(indCurrID, indicatorObjList, value) {

    let indObj = getIndObj(indCurrID, indicatorObjList);
    indObj[rcc.powerChangeInputs_I_PC_C][rcc.designEffectNum_I_PC_C] = value;

    //console.log("Set design effect: " + value);

}

/*************************   Target population inputs   ********************************/

export function getTargPopObj(targPopCurrID, targPopObjList) {

    return targPopObjList[targPopCurrID - 1];

}

export function getTargPopName(targPopCurrID, targPopObjList) {

    const targPopObj = getTargPopObj(targPopCurrID, targPopObjList);
    return targPopObj[rcc.name_TP_C];

}

export function setTargPopName(targPopCurrID, targPopObjList, value) {

    let targPopObj = getTargPopObj(targPopCurrID, targPopObjList);
    targPopObj[rcc.name_TP_C] = value;

}

export function getTargPopParamName(targPopCurrID, targPopObjList) {

    const targPopObj = getTargPopObj(targPopCurrID, targPopObjList);
    return targPopObj[rcc.paramName_TP_C];

}

export function setTargPopParamName(targPopCurrID, targPopObjList, value) {

    let targPopObj = getTargPopObj(targPopCurrID, targPopObjList);
    targPopObj[rcc.paramName_TP_C] = value;

}

/*******************************   Group inputs   **************************************/

function getGroupObj(groupCurrID, groupObjList) {

    return groupObjList[groupCurrID - 1];

}

export function getNumGroups(groupObjList) {

    return groupObjList.length;

}

export function addGroup(name, mstID, groupObjList) {

    groupObjList.push(rcu.createGroupObj(name, mstID));

}

export function getGroupMstID(groupCurrID, groupObjList) {

    const groupObj = getGroupObj(groupCurrID, groupObjList);
    return groupObj[rcc.mstID_G_C];

}

export function setGroupMstID(groupCurrID, groupObjList, value) {

    let groupObj = getGroupObj(groupCurrID, groupObjList);
    groupObj[rcc.mstID_G_C] = value;

}

export function getGroupName(groupCurrID, groupObjList) {

    const groupObj = getGroupObj(groupCurrID, groupObjList);
    return groupObj[rcc.name_G_C];

}

export function setGroupName(groupCurrID, groupObjList, value) {

    let groupObj = getGroupObj(groupCurrID, groupObjList);
    groupObj[rcc.name_G_C] = value;

}

export function getGroupPanelExpanded(groupCurrID, groupObjList) {

    const groupObj = getGroupObj(groupCurrID, groupObjList);
    return groupObj[rcc.panelExpanded_G_C];

}

export function setGroupPanelExpanded(groupCurrID, groupObjList, value) {

    let groupObj = getGroupObj(groupCurrID, groupObjList);
    groupObj[rcc.panelExpanded_G_C] = value;

}

/*****************************   Utility methods *************************************/

export function getIndParamName(paramType, targPopCurrID, targPopObjList) {

    let paramName;

    switch (paramType) {

        case rcc.targPopParam :
            paramName = getTargPopParamName(targPopCurrID, targPopObjList);
            break;

        case rcc.intervHHsParam :
            paramName = RS(SC.GB_stNumIntervHHs);
            break;

        case rcc.HHResponseRateParam :
            paramName = RS(SC.GB_stHHResponseRate);
            break;

        default :
            paramName = "";
            break;

    }

    return paramName;

}

export function getIndParamValue(paramType, indCurrID, indicatorObjList) {

    let paramValue;

    switch (paramType) {

        case rcc.targPopParam :
            paramValue = getIndTargPopValue(indCurrID, indicatorObjList);
            break;

        case rcc.intervHHsParam :
            paramValue = getIndNumIntervHHs(indCurrID, indicatorObjList);
            break;

        case rcc.HHResponseRateParam :
            paramValue = getIndPropHHResponseRate(indCurrID, indicatorObjList);
            break;

        default :
            paramValue = 0;
            break;

    }

    return paramValue;

}

export function setIndParamValue(paramType, indCurrID, indicatorObjList, value) {

    switch (paramType) {

        case rcc.targPopParam :
            setIndTargPopValue(indCurrID, indicatorObjList, value);
            break;

        case rcc.intervHHsParam :
            setIndNumIntervHHs(indCurrID, indicatorObjList, value);
            break;

        case rcc.HHResponseRateParam :
            setIndPropHHResponseRate(indCurrID, indicatorObjList, value);
            break;

        default :
            break;

    }

}

export function replaceTargPopParams(
    paramType, indCurrID, indicatorObjList, targPopObjList) {

    let paramName = "";

    const startAge = getIndTargPopLabStartAge(indCurrID, indicatorObjList);
    const endAge = getIndTargPopLabEndAge(indCurrID, indicatorObjList);
    const refPeriod = getIndTargPopLabRefPeriod(indCurrID, indicatorObjList);
    const gender = getIndTargPopLabGender(indCurrID, indicatorObjList);
    const targPopCurrID = getIndTargPopCurrID(indCurrID, indicatorObjList);

    paramName = getIndParamName(paramType, targPopCurrID, targPopObjList);

    if (startAge !== RS(SC.GB_stNA)) {

        paramName = paramName.replace(RS(SC.GB_stXX), startAge);

    }

    if (endAge !== RS(SC.GB_stNA)) {

        paramName = paramName.replace(RS(SC.GB_stYY), endAge);

    }

    if ((startAge !== RS(SC.GB_stNA)) &&
        (endAge !== RS(SC.GB_stNA)) &&
        (startAge === endAge)) {

        paramName = paramName.replace(startAge.toString() + "-" + endAge.toString(), startAge);

    }

    if (refPeriod !== RS(SC.GB_stNA)) {

        paramName = paramName.replace(RS(SC.GB_stZZ), refPeriod);

    }

    if (gender !== RS(SC.GB_stNA)) {

        let genderHolderStr = RS(SC.GB_stWomenSlashMen);

        paramName = paramName.replace(
            genderHolderStr.toLowerCase(),
            getGenderPlural(gender, false).toLowerCase());

    }

    return paramName;

}

/* All of the parameters and results table that show indicators have the same rows, so
   this function can be used to determine the number of rows any of them will have. */
export function getIndTableNumRows(indicatorObjList, groupObjList) {

    let row = 1;

    let addedGroupsMstIDArray = [];

    for (let i = 1; i <= indicatorObjList.length; i++) {

        const indObj = indicatorObjList[i - 1];

        /* Only include the indicator in the table if the user wished to analyze it. */
        if (indObj[rcc.analyzeBool_I_C]) {

            const groupObj = groupObjList[indObj[rcc.groupCurrID_I_C] - 1];

            /* Write the indicator's group out first if its group has not been written out yet. */
            if (!addedGroupsMstIDArray.includes(groupObj[rcc.mstID_G_C])) {

                addedGroupsMstIDArray.push(groupObj[rcc.mstID_G_C]);

                row++;

            }

            row++;

        }

    }

    return row;

}

export function getIndStatus(indCurrID, indicatorObjList) {

    const customIndBool = getIndCustomBool(indCurrID, indicatorObjList);
    const indTargPopType = getIndTargPopType(indCurrID, indicatorObjList);
    const customTargPop = (indTargPopType === rcc.customTargPop);

    let status = rcc.indCompleted;

    /* Make sure HH conversion factor parameters are all greater than 0. This must be
       the case for indicators of all types. */
    let i = 1;
    while ((i <= rcc.numHHConvFactorParams) && (status === rcc.indCompleted)) {

        const paramValue = getIndParamValue(i, indCurrID, indicatorObjList);

        if (!(paramValue > 0)) {

            status = rcc.indIncomplete;

        }

        i++;

    }

    /* If we are not looking at a custom indicator using a custom target population, then
       make sure target population parameters are all selected, if they are applicable. */
    if ((status !== rcc.indIncomplete) && (!(customIndBool && customTargPop))) {

        /* If the indicator is custom, we have to pass in the current ID of a default
           intervention when using any of the getDef methods below instead of the custom
           intervention current ID, since these methods are meant for default interventions only. This
           works because all default interventions have only one choice of target population, and that
           target population is associated with the default intervention object. This should eventually
           be changed, however, so we don't need to pass a default intervention's ID in (the getDef methods
           should take a targ pop ID instead). */
        let defIndCurrID = indCurrID;
        if (customIndBool) {
            const targPopCurrID = getIndTargPopCurrID(indCurrID, indicatorObjList);
            defIndCurrID = getDefIndCurrIDFromTargPopCurrID(targPopCurrID);

        }

        const defIndAgeLowerBoundStart = getDefIndAgeLowerBoundStart(defIndCurrID);
        const defIndAgeLowerBoundEnd = getDefIndAgeLowerBoundEnd(defIndCurrID);
        const defIndAgeUpperBoundStart = getDefIndAgeUpperBoundStart(defIndCurrID);
        const defIndAgeUpperBoundEnd = getDefIndAgeUpperBoundEnd(defIndCurrID);
        const startAge = getIndTargPopLabStartAge(indCurrID, indicatorObjList);
        const endAge = getIndTargPopLabEndAge(indCurrID, indicatorObjList);

        const defIndRefPeriod = getDefIndRefPeriod(defIndCurrID);
        const refPeriod = getIndTargPopLabRefPeriod(indCurrID, indicatorObjList);

        const defIndGender = getDefIndGender(defIndCurrID);
        const gender = getIndTargPopLabGender(indCurrID, indicatorObjList);

        /* If the user needs to fill out lower age bounds...*/
        if ((defIndAgeLowerBoundStart !== RS(SC.GB_stNA)) &&
            (defIndAgeLowerBoundEnd !== RS(SC.GB_stNA))) {

            /* If the user did not fill out a start age.. */
            if (startAge === RS(SC.GB_stNA)) {

                status = rcc.indIncomplete;

            }

        }

        /* If the user needs to fill out upper age bounds...*/
        if ((defIndAgeUpperBoundStart !== RS(SC.GB_stNA)) &&
            (defIndAgeUpperBoundEnd !== RS(SC.GB_stNA))) {

            /* If the user did not fill out an end age... */
            if (endAge === RS(SC.GB_stNA)) {

                status = rcc.indIncomplete;

            }

        }

        /* If the user needs to fill out a reference period...*/
        if (defIndRefPeriod !== RS(SC.GB_stNA)) {

            /* If the user did not fill out a reference period... */
            if (refPeriod === RS(SC.GB_stNA)) {

                status = rcc.indIncomplete;

            }


        }

        /* If the user needs to fill out a gender...*/
        if (defIndGender !== RS(SC.GB_stNA)) {

            /* If the user did not fill out a gender... */
            if (gender === RS(SC.GB_stNA)) {

                status = rcc.indIncomplete;

            }

        }

    }

    return status;

}

export function allIndCompleted(indicatorObjList) {

    let allCompleted = true;

    let i = 1;
    while ((i <= indicatorObjList.length) && (allCompleted)) {

        const analyze = getIndAnalyzeBool(i, indicatorObjList);
        const status = getIndStatus(i, indicatorObjList);

        if (analyze && (status === rcc.indIncomplete)) {

            allCompleted = false;

        }

        i++;

    }

    return allCompleted;

}

export function getNumIndCompleted(indicatorObjList) {

    let numIndAnalyzed = 0;

    for (let i = 1; i <= indicatorObjList.length; i++) {

        const analyze = getIndAnalyzeBool(i, indicatorObjList);
        const status = getIndStatus(i, indicatorObjList);

        if (analyze && (status === rcc.indCompleted)) {

            numIndAnalyzed++;

        }

    }

    return numIndAnalyzed;

}

export function getNumIndAnalyzed(indicatorObjList) {

    let numIndAnalyzed = 0;

    for (let i = 1; i <= indicatorObjList.length; i++) {

        const analyze = getIndAnalyzeBool(i, indicatorObjList);

        if (analyze) {

            numIndAnalyzed++;

        }

    }

    return numIndAnalyzed;

}

/* default + custom */
export function getTotalNumInd(indicatorObjList) {

    return indicatorObjList.length;

}

export function getNumCustomInd(indicatorObjList) {

    let numCustomInd;


    /* Custom indicators are always at the end of the indicatorObjList after
       numDefIndicators. */
    const totalNumInd = getTotalNumInd(indicatorObjList);
    numCustomInd = totalNumInd - rcc.numDefIndicators;

    return numCustomInd;

}

export function getFirstUnusedCustomIndMstID(indicatorObjList) {

    let firstUnusedMstID = rcc.minCustIndMstID;

    const numCustomInd = getNumCustomInd(indicatorObjList);
    const totalNumInd = getTotalNumInd(indicatorObjList);

    if (numCustomInd > 0) {

        let value = 0;

        for (let i = rcc.numDefIndicators + 1; i <= totalNumInd; i++) {

            const indMstID = getIndMstID(i, indicatorObjList);
            value = Math.max(indMstID, value);

        }

        firstUnusedMstID = value + 1;

    }

    return firstUnusedMstID;

}

export function getNewCustomIndName(indicatorObjList) {

    const nameRoot = RS(SC.GB_stCustomIndicator) + " ";

    const numCustomInd = getNumCustomInd(indicatorObjList);
    const totalNumInd = getTotalNumInd(indicatorObjList);

    let value = 1;

    if (numCustomInd > 0) {

        for (let i = rcc.numDefIndicators + 1; i <= totalNumInd; i++) {

            const indName = getIndName(i, indicatorObjList);

            if (indName.indexOf(nameRoot) === 0) {

                let indNum = parseInt(indName.replace(nameRoot, ""));
                if (typeof indNum === "number") {

                    value = Math.max(indNum, value);

                }

            }

        }

        value++;

    }

    return nameRoot + value;

}

export function getIndCurrID(indMstID, indicatorObjList) {

    let indCurrID = 0;

    const totalNumInd = getTotalNumInd(indicatorObjList);

    let i = 1;
    while ((i <= totalNumInd) && (indCurrID === 0)) {

        const indMstIDL = getIndMstID(i, indicatorObjList);

        if (indMstIDL === indMstID) {

            indCurrID = i;

        }

        i++;
    }

    return indCurrID;

}

/**************   Methods for adding, editing, deleting, and otherwise manipulating custom indicators *********/

export function addIndicator(indicatorObjList, selectedIndCurrID) {

    let selectedIndCurrIDL = selectedIndCurrID;

    const newIndName = getNewCustomIndName(indicatorObjList);
    const newIndMstID = getFirstUnusedCustomIndMstID(indicatorObjList);
    const newIndTargPopCurrID = 1;
    const newIndGroupCurrID = rcc.customIndGroupCurrID;

    let newIndObj = createIndObj(newIndName, newIndMstID, newIndTargPopCurrID, newIndGroupCurrID);

    indicatorObjList.push(newIndObj);

    const totalNumInd = getTotalNumInd(indicatorObjList);

    setIndCustomBool(totalNumInd, indicatorObjList, true);

    /* If the user is actively going out of the way to create the indicator, assume they want
       it analyzed. */
    selectedIndCurrIDL = onAnalyzeIndicatorChange(totalNumInd, true, indicatorObjList, selectedIndCurrIDL);

    return selectedIndCurrIDL;
}

export function deleteIndicators(indicatorObjList, indCurrID1DIntArray, selectedIndCurrID) {

    let selectedIndCurrIDL = selectedIndCurrID;

    for (let i = indCurrID1DIntArray.length; i >= 1; i--) {

        const indCurrID = indCurrID1DIntArray[i - 1];

        /* The indicator can't be analyzed anymore, so turn it off first. This will handle
           the selected indicator logic too. */
        selectedIndCurrIDL = onAnalyzeIndicatorChange(indCurrID, false, indicatorObjList, selectedIndCurrIDL);

        indicatorObjList.splice(indCurrID - 1, 1);

    }

    return selectedIndCurrIDL;

}

export function moveIndicators(indicatorObjList, indCurrID1DIntArray, direction) {

    /* Instead of moving the indicator(s) we want to move, move the one above/below them.
       If moving the indicator block down, put the indicator immediately after the block
       before the first indicator in block. If moving the indicator block up, put the
       indicator immediately below the block after the last indicator in the block.

       NOTE: Down in this case means towards the bottom of the screen and up means towards the
       top. */

    const totalNumInd = getTotalNumInd(indicatorObjList);

    const firstIndInBlockCurrID = indCurrID1DIntArray[0];
    const lastIndInBlockCurrID = indCurrID1DIntArray[indCurrID1DIntArray.length - 1];

    if ((direction === rcc.moveDown) && (lastIndInBlockCurrID !== totalNumInd)) {

        const indObjArray = indicatorObjList.splice((lastIndInBlockCurrID + 1) - 1, 1);
        indicatorObjList.splice(firstIndInBlockCurrID - 1, 0, indObjArray[0]);

    }
    else if ((direction === rcc.moveUp) && (firstIndInBlockCurrID !== (rcc.numDefIndicators + 1))) {

        let indObjArray = indicatorObjList.splice((firstIndInBlockCurrID - 1) - 1, 1);
        /* Careful; since we removed the indiactor below the block, the current IDs of all
           indicators in the block will be decreased by one now. So, it's - 1 because the
           indicators' current IDs shifted down 1, - 1 because the current ID is one more than
           the index of the object list, and +1 to put the removed indicator after the block. */
        indicatorObjList.splice(((lastIndInBlockCurrID - 1) - 1) + 1, 0, indObjArray[0]);

    }

}

export function onIndicatorTargPopCurrIDChange(indCurrID, indicatorObjList) {

    if (indCurrID !== 0) {

        const indPossibleTargPop1DIntArray =
            getIndPossibleTargPop1DIntArray(indCurrID, indicatorObjList);

        setIndTargPopCurrID(indCurrID, indicatorObjList, indPossibleTargPop1DIntArray[0]);

    }

}

/* Call this when any indicator is activated or deactivated for the analysis. Code was moved here
   from RCApp because we want to call this in a drawer where we hold intermediate state. */
export function onAnalyzeIndicatorChange(indCurrID, analyzeBool, indicatorObjList, selectedIndCurrID) {

    let selectedIndCurrIDL = selectedIndCurrID;

    /* If one indicator was (de)selected, ... */
    if (indCurrID !== rcc.allIndicators) {

        setIndAnalyzeBool(indCurrID, indicatorObjList, analyzeBool);

        /* If an indicator is activated for analysis, then... */
        if (analyzeBool) {

            /* If the selected indicator is currently 0, then we need to set the selected indicator to the
               one that was just activated for analysis.*/
            if (selectedIndCurrID === 0) {

                selectedIndCurrIDL = indCurrID;

                onIndicatorTargPopCurrIDChange(indCurrID, indicatorObjList);

            }

        }
        /* Otherwise, an indicator was just deactivated. */
        else {

            /* If the deactivated indicator was the selected indicator, set the selected indicator to the first
               available selected indicator or to 0 if no such indicator exists. */
            if (selectedIndCurrID === indCurrID) {

                const indSelectedBool = getAnyIndicatorSelected(indicatorObjList);

                let newSelectedIndCurrID = 0;

                if (indSelectedBool) {

                    newSelectedIndCurrID = getFirstIndSelectedForAnalysis(indicatorObjList);

                }

                selectedIndCurrIDL = newSelectedIndCurrID;

                if (newSelectedIndCurrID !== 0) {

                    onIndicatorTargPopCurrIDChange(newSelectedIndCurrID, indicatorObjList);

                }

            }

        }

    }
    /* Otherwise, all indicators were (de)selected. */
    else {

        const totalNumInd = getTotalNumInd(indicatorObjList);

        for (let i = 1; i <= totalNumInd; i++) {

            setIndAnalyzeBool(i, indicatorObjList, analyzeBool);

        }

        /* If all indicators were just activated for analysis, then... */
        if (analyzeBool) {

            /* If the selected indicator is currently 0, then we need to set the selected indicator to the
               first one.*/
            if (selectedIndCurrID === 0) {

                selectedIndCurrIDL = 1;

                onIndicatorTargPopCurrIDChange(1, indicatorObjList);

            }

        }
        /* Otherwise, all indicators were just deactivated. */
        else {

            selectedIndCurrIDL = 0;

        }

    }

    return selectedIndCurrIDL;

}